// TODO ISO 27001: confirmar con el back el contrato real del stream de RMIGRA.
// Se asume el mismo patrón que gate-monitor/stream (ver
// src/pages/miakey/admin/monitor/services/registros.js): POST directo al SSE
// Manager con headers Hooli, body { pasos: [migraPasoId], ultimoEventoId? } y
// eventos que solo traen { id }.

import { log } from "utils/logger";
import { migraUsuarioPasoGet } from "services/services-mia/migra";
import { mapMigraUsuarioPasoRow } from "pages/migra/utils/usuarioPaso";
import { SSE_URL } from "consts/env";

export { getStreamHeaders } from "services/services-mia/getStreamHeaders";

export const MIGRA_SSE_STREAM_URL = `${SSE_URL}/migra-monitor/stream`;

export const migraUsuarioPasoDetalleGet = async ({ id, credentials }) => {
    // TODO ISO 27001: sacar este log una vez confirmado con el back que
    // MigraUsuarioPasoGet realmente filtra por migraUsuarioPasoId.
    log.debug(`[migra-monitor] Pidiendo detalle para migraUsuarioPasoId=${id}`);

    const response = await migraUsuarioPasoGet({ migraUsuarioPasoId: id }, credentials);

    if (response?.status?.code !== 1) {
        log.error(`[migra-monitor] MigraUsuarioPasoGet (detalle) rechazado [errcode=${response?.status?.errcode}]`);
        throw new Error("No se pudo obtener el detalle");
    }

    const item = response.result?.[0];
    log.debug(`[migra-monitor] Detalle recibido: pedido=${id}, recibido=${item?.migraUsuarioPasoId}`);
    return item ? mapMigraUsuarioPasoRow(item) : null;
};
